import React, { PropTypes } from 'react';
import Select from 'react-select';
import { selectify } from "../../businessLogic/util";
import RemoveAccents from 'remove-accents';

export default class SearchBar extends React.Component {

	componentWillMount() {
		this.props.getGroups();
		this.props.getKeywords();
		this.props.getShapes();
		this.props.getFolders();		
	}

	getFilterBar() {
		return (
			<form onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				const tokens = this._filter.value.split(" ");
				const terms = [];
				tokens.map((t) => { 
					const parsed = RemoveAccents.remove(t.trim().normalize().toLowerCase());
					if ( parsed !== "" ) terms.push(parsed);
				});

				if ( terms.length > 0 ) {
					this.props.actions.setSearchTerms(terms);
				} else {
					this.props.actions.setSearchTerms([]);
				} 
			}}>
				<div className="select-group">
					<div style={{width: "700px", display: "flex", justifyContent: "space-between"}}>
						<div className="form-group" style={{width: "485px"}}>
							<input 
								type="text" 
								className="form-control" 						
								placeholder="Digite aqui para buscar nos documentos"								
								ref={(node) => this._filter = node}
								onChange={(e) => { 
									if ( e.target.value === "" ) {			
										this.props.actions.setSearchTerms([]);
									}
								}}							
							/>						
						</div>

						<div className="checkbox">
							<label>
								<input 
									type="checkbox"
									checked={this.props.filter.wholeWord}
									onClick={(e) => this.props.actions.setWholeWordOnly(e.target.checked)}
								/> 
								Apenas Palavras Completas
							</label>
						</div>
					</div>
				</div>
			</form>
		);
	}

	render () {
		const { filter, actions, folders, groups, keywords, shapes } = this.props;
		groups.list.sort(function(a, b) {
			var textA = a.name.toUpperCase();
			var textB = b.name.toUpperCase();
			return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
		});

		return (
			<div>	
				{this.getFilterBar()}	
				<div className="select-group">
					<div style={{width: "700px", display: "flex", justifyContent: "space-between"}}>
						<div className="form-group" style={{width: "210px"}}>							
							<Select
								name="folder-select"
								options={selectify(folders.list.filter((f) => {
									if (this.props.projects.isMariana === true && this.props.projects.isBrumadinho === true) {
										return f;										
									} else {
										if (f.projeto.length > 1) {
											return f;
										}
										if (this.props.projects.isMariana === true)	return (f.projeto[0] === 1 );
										if (this.props.projects.isBrumadinho === true) return (f.projeto[0] === 2 );
									}
								}))}
								value={filter.folder}													
								placeholder="Mostrar Todas as Pastas"							
								clearAllText="Limpar opções"
								onChange={(value) => actions.setFolder(value)}							
							/>							
						</div>
						<div className="form-group" style={{width: "290px"}}>							
							<Select
								name="groups-select"
								options={selectify(groups.list.filter((s) => {
									if (this.props.projects.isMariana === true && this.props.projects.isBrumadinho === true) {
										return s;										
									} else {
										if (s.idProjeto === 3) {
											return s;
										}
										if (this.props.projects.isMariana === true)	return (s.idProjeto === 1 );
										if (this.props.projects.isBrumadinho === true) return (s.idProjeto === 2);
									}
								}))}
								value={filter.selectedGroups}													
								placeholder="Selecionar Grupos"
								multi
								clearAllText="Limpar opções"
								onChange={(value) => actions.setGroups(value)}
							/>							
						</div>
						<div className="form-group" style={{width: "160px"}}>
							<div className="checkbox">
								<label>
									<input 
										type="checkbox"
										checked={this.props.filter.visibility === 'favorites'}
										onClick={(e) => actions.setVisibility(e.target.checked ? 'favorites' : 'all')}
									/> 
									Apenas Favoritos <i className="fa fa-star" style={{color: "#908989"}} />
								</label>
							</div>
						</div>					
					</div>
				</div>
				<div className="select-group">
					<div style={{width: "700px", display: "flex", justifyContent: "space-between"}}>
						<div className="form-group" style={{width: "240px"}}>							
							<Select
								name="keywords-select"
								options={selectify(keywords.list)}
								value={filter.selectedKeywords}													
								placeholder="Selecionar Palavras-Chave"
								multi
								clearAllText="Limpar opções"
								onChange={(value) => actions.setKeywords(value)}
							/>							
						</div>
						<div className="form-group" style={{width: "220px"}}>							
							<Select
								name="sectors-select"
								options={selectify(shapes.list.filter((s) => {
									if (this.props.projects.isMariana && this.props.projects.isBrumadinho) {
										if (s.shapeType === 5)	return true;
									} else {
										if (this.props.projects.isMariana && s.projeto === 1 ) {
											if (s.shapeType === 5)	return true;
										}
										if (this.props.projects.isBrumadinho && s.projeto === 2 ) {
											if (s.shapeType === 5)	return true;
										}
									} 
								}))}
								value={filter.selectedSectors}
								placeholder="Selecionar Setores"
								multi
								clearAllText="Limpar opções"
								onChange={(value) => actions.setSectors(value)}
							/>							
						</div>
						<div className="form-group" style={{width: "220px"}}>							
							<Select
								name="localities-select"
								options={selectify(shapes.list.filter((s) => {
									if (this.props.projects.isMariana && this.props.projects.isBrumadinho) {
										if (s.shapeType === 4)	return true;
									} else {
										if (this.props.projects.isMariana && s.projeto === 1 ) {
											if (s.shapeType === 4)	return true;
										}
										if (this.props.projects.isBrumadinho && s.projeto === 2 ) {
											if (s.shapeType === 4)	return true;
										}
									} 
								}))}
								value={filter.selectedLocalities}
								placeholder="Selecionar Localidades"
								multi
								clearAllText="Limpar opções"
								onChange={(value) => actions.setLocalities(value)}
							/>							
						</div>
					</div>
				</div>
			</div>				
		);
	}
}

SearchBar.propTypes = {
	actions: PropTypes.object.isRequired,
	filter: PropTypes.object.isRequired,
	groups: PropTypes.object.isRequired,
	folders: PropTypes.object.isRequired,
	keywords: PropTypes.object.isRequired,
	shapes: PropTypes.object.isRequired,
	getGroups: PropTypes.func.isRequired,
	getShapes: PropTypes.func.isRequired,
	getKeywords: PropTypes.func.isRequired,
	getFolders: PropTypes.func.isRequired,
	projects: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/SearchBar.js